import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useChampionsTournamentWidgetData } from '../../hooks/useChampionsTournamentWidgetData';
import type { ChampionsTournamentWidgetDataType, WidgetSizeType } from '../../types';
import { TournamentWidgetTimer } from '../TournamentWidget/TournamentWidgetTimer/TournamentWidgetTimer';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { ChampionsTournamentSmallWidget } from './ChampionsTournamentSmallWidget/ChampionsTournamentSmallWidget';
import { ChampionsTournamentWideWidget } from './ChampionsTournamentWideWidget/ChampionsTournamentWideWidget';

interface ChampionsTournamentWidgetProps {
  sizeType: WidgetSizeType;
  data: ChampionsTournamentWidgetDataType;
}

function ChampionsTournamentWidgetComponent(props: ChampionsTournamentWidgetProps) {
  const { sizeType } = props;
  const { t } = useTranslation();
  const {
    hasToc,
    widgetImageUrl,
    positionValue,
    timer,
    showStartsInLabel,
    showEmptyPositionBar,
    handleClick,
    onTimerEnd,
  } = useChampionsTournamentWidgetData();

  if (!hasToc) return null;

  const timerNode = timer ? (
    <TournamentWidgetTimer
      endDate={timer.endDate}
      extended={sizeType === 'wide'}
      noPosition={positionValue == null}
      startDate={timer.startDate}
      to={timer.to}
      onEnd={onTimerEnd}
    />
  ) : undefined;

  const startsInLabel = showStartsInLabel ? t('tournament.startsIn') : undefined;

  return (
    <WidgetWrapper smallWidgetExtended sizeType={sizeType} onClick={handleClick}>
      {sizeType === 'small' ? (
        <ChampionsTournamentSmallWidget
          positionValue={positionValue}
          showEmptyPositionBar={showEmptyPositionBar}
          startsInLabel={startsInLabel}
          timer={timerNode}
          widgetImageUrl={widgetImageUrl}
        />
      ) : (
        <ChampionsTournamentWideWidget
          positionValue={positionValue}
          startsInLabel={startsInLabel}
          timer={timerNode}
          widgetImageUrl={widgetImageUrl}
        />
      )}
    </WidgetWrapper>
  );
}

export const ChampionsTournamentWidget = observer(ChampionsTournamentWidgetComponent);
